var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAffordableHighQIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2110",
    "data-name": "Group 2110",
    transform: "translate(-788 -1308)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(788 1308)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "low-price",
    transform: "translate(701.541 1318.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3502",
    "data-name": "Path 3502",
    d: "M128.089,11.629a11.629,11.629,0,1,0-11.629,11.629A11.642,11.642,0,0,0,128.089,11.629Zm-16.141,2.785h2.308a1.452,1.452,0,0,0,1.45,1.45h1.482a1.5,1.5,0,1,0,0-2.994h-1.456a3.8,3.8,0,0,1-.426-7.585V3.365h2.308V5.29a3.811,3.811,0,0,1,3.347,3.777h-2.308a1.5,1.5,0,0,0-1.5-1.5h-1.423a1.5,1.5,0,1,0,0,2.994h1.456a3.8,3.8,0,0,1,.426,7.584v1.92h-2.308V18.15a3.763,3.763,0,0,1-3.358-3.736Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3503",
    "data-name": "Path 3503",
    d: "M124.542,302.387a13.906,13.906,0,0,1-15.34,0v5.051h-3.925v1.668l11.595,9.407,11.595-9.407v-1.668h-3.925v-5.051Z",
    transform: "translate(-0.413 -279.127)",
    fill: "#fafafa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffordableHighQIcon);
export default __webpack_public_path__ + "static/media/affordable-highQ-icon.c96644fa32524db3b931f8f3ff5caca8.svg";
export { ForwardRef as ReactComponent };